import React, { useEffect } from 'react';
import PartnershipStyles from "./Partnership.module.css";
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FilterListIcon from '@mui/icons-material/FilterList';
import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';

// import this for redux read write
import { useSelector, useDispatch } from 'react-redux';
import { setNotifications } from '../../state/GlobalState';
import { setNotificationCount } from '../../state/GlobalState';
import { fetchNotifications } from '../../state/GlobalState';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

function createData(id, name, email, number, date, job) {
    return { id, name, email, number, date, job };
}

const rows = [
    // createData(1, 'Joseph William 1', 'Joseph@mail.com', 901235456, "12.07.2018", "JS Developer"),
    // createData(2, 'Ashy Handgun 2', 'Akshay@mail.com', 1403500365, "12.07.2018", "HR"),
    // createData(3, 'Larry Doe 3', 'larry@mail.com', 6048323973, "12.07.2018", "React JS Developer"),
    // createData(4, 'Sara Soudan 4', 'Sara@mail.com', 3272117434, "12.07.2018", "Sales Head"),
    // createData(5, 'Larry Doe 3', 'larry@mail.com', 3760221303, "12.07.2018", "Jr React Developer"),
    // createData(6, 'Joseph William 1', 'Joseph@mail.com', 925475400, "12.07.2018", "Node JS Developer"),
    // createData(7, 'Sara Soudan 4', 'Sara@mail.com', 830192060, "12.07.2018", "Spring Boot Developer"),
    // createData(8, 'Joseph William 1', 'Joseph@mail.com', 485237000, "12.07.2018", "HR"),
    // createData(9, 'Ashy Handgun 2', 'Akshay@mail.com', 126577691, "12.07.2018", "React JS Developer"),
    // createData(10, 'Larry Doe 3', 'larry@mail.com', 126317000, "12.07.2018", "Sales"),
    // createData(11, 'Sara Soudan 4', 'Sara@mail.com', 678022000, "12.07.2018", "JS Developer"),
    // createData(12, 'Joseph William 1', 'Joseph@mail.com', 672545757, "12.07.2018", "IOS Developer"),
    // createData(13, 'Jack parrow', 'Akshay@mail.com', 146793744, "12.07.2018", "Data Scientist"),
    // createData(14, 'Larry Doe 3', 'larry@mail.com', 2009624137, "12.07.2018", "Sales Head"),
    // createData(15, 'Joseph William 5', 'larry@mail.com', 210147125, "12.07.2018", "HR"),
];




const Partnership = () => {

    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 480,
        bgcolor: 'background.paper',
        // border: '2px solid gray',
        // boxShadow: '2px 2px 10px 2px gray',
        borderRadius: '5px',
        p: 4,
    };

    //   const [style, setStyle] = useState(null);
//   const [listStyle, setListStyle] = useState(null);
//   const [selectedData, setSelectedData] = useState(null);

  const [selectedData, setSelectedData] = useState({})
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [view, setView] = useState(false)
  const handleView = (row) => {
      setView(true)
      console.log(row)
      setSelectedData(row)

  }
  const handleViewClose = () => setView(false)
  

  const name=useSelector((state)=>state.globalData.name);
  const count=useSelector((state)=>state.globalData.notificationCount);
  const dispatch =  useDispatch()


    const [data, setData] = useState([])

    const getApplicantData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_STEELADMIN}/partnerUs/getAll`
            )
            setData(res.data)
            // console.error("helloss")
            // console.log(res.data)
            // console.log(res.data[0].jobrole[0].resume[0].userAppForm.applicantName)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getApplicantData();

    }, [])




    const [jobRole, setJobRole] = React.useState("");

    const handleJobRoles = (event) => {
        setJobRole(event.target.value);
    };

    // const [open, setOpen] = useState(false);
    // const handleOpen = () => setOpen(true);
    // const handleClose = () => setOpen(false);

    const [query, setQuery] = useState("");

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const deleteApplicantbyId = async (partnerId) => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_STEELADMIN}/partnerUs/deletePartnerFormById/${partnerId}`
            )
                console.log( res)
              // this is the snipte for the notification
           dispatch(fetchNotifications())

           dispatch(setNotificationCount({
            count:count+1,
           }))
                 
                 
               //   uptill here 
  
            alert('Delete Successful!')
            // window.location.reload()
            
        } catch (error) {
            console.log(error);
        }
        getApplicantData();
    }

    const filteredData = [];
    //  = (data.flatMap((category) =>
        // category.jobrole
        //     .filter((job) => {
        //         if (jobRole === 'All Roles') {
        //             return true; // Include all job roles
        //         } else {
        //             return job.careerJobRoleName.includes(jobRole); // Filter based on jobRole
        //         }
        //     })
        //     .flatMap((job) =>
        //         job.resume.filter((row) =>
        //             row.userAppForm.applicantName.toLowerCase().includes(query)
        //         )
        //             .map((row) => (
        //                 {
        //                     careerCategoryName: category.careerCategoryName,
        //                     careerJobRoleName: job.careerJobRoleName,
        //                     job: job,
        //                     ...row,
        //                 }
        //             ))
            //  )
    // );




      console.log(filteredData)


    return (
        <>
            <Card sx={{ maxWidth:'95%', border: 'none', outline:'none',boxShadow:'none', mt:'3%' }}>
                <CardContent>
                    <Paper className={PartnershipStyles.myboder}>
                        <TableContainer sx={{ maxHeight: 650 }}>
                            <div className={PartnershipStyles.jobApplicantListBox1}>
                                <Box className={PartnershipStyles.Box1}>
                                    <Typography variant='h5' 
                                    sx={{
                                        fontWeight:'500',
                                        fontSize:'20px',
                                        lineHeight:'24px',
                                        color:'#121926'
                                        }}>Partner applicants </Typography>
                                    <Typography variant='h6'>101 Applications</Typography>
                                </Box>
                            </div>
                            <div className={PartnershipStyles.jobApplicantListBox2}>
                                <Box className={PartnershipStyles.Box1}>
                                <Search>
                                        <SearchIconWrapper>
                                            <SearchIcon sx={{ zIndex: '1' }} />
                                        </SearchIconWrapper>
                                        <StyledInputBase
                                            placeholder="Search…"
                                            onChange={(e) => setQuery(e.target.value)}
                                            inputProps={{ 'aria-label': 'search' }}
                                            sx={{ width: '100%', color: '#121926', backgroundColor: '#F8FAFC', borderRadius: '10px', border: '1px solid #bdbdbd' }}
                                        />
                                    </Search>
                                </Box>
                                {/* <Box className={PartnershipStyles.Box2}>
                                    Filter by
                                    <FormControl sx={{ m: 1, width: '200px' }}>
                                        <Select
                                            value={jobRole}
                                            // filter={job.careerJobRoleName}
                                            onChange={handleJobRoles}
                                            displayEmpty
                                            inputProps={{ "aria-label": "Without label" }}
                                            style={{height:'5vh'}}
                                        >

                                            <MenuItem value="">All Roles</MenuItem>
                                            <MenuItem value='Javascript'>Javascript</MenuItem>
                                            <MenuItem value='Technical'>Technical</MenuItem>
                                            <MenuItem value='React JS Developer'>React JS Developer</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box> */}
                            </div>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow className={PartnershipStyles.Mainhead}>
                                        <TableCell className={PartnershipStyles.Tablehead}>User</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>IP Address</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Company</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Type</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Registered</TableCell>
                                        <TableCell className={PartnershipStyles.Tablehead}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {

                                        data
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row) => {
                                                return (
                                                    <TableRow className={PartnershipStyles.MainRow} hover role="checkbox" tabIndex={-1} key={row.partnerId} >
                                                        <TableCell className={PartnershipStyles.Tablerow1}> {row.partnerName}<Box className={PartnershipStyles.Email}>{row.email}</Box></TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            {row.ipAddress}
                                                        </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow1}> {row.companyName}<Box className={PartnershipStyles.Email}>{row.companyWebsite}</Box></TableCell>
                                                        {/* <TableCell className={PartnershipStyles.Tablerow}>{row.companyName} </TableCell> */}
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            {row.rolesDetails}
                                                        </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow}>
                                                            {row.dateCreated}
                                                        </TableCell>
                                                        <TableCell className={PartnershipStyles.Tablerow2}>
                                                            {/* <Link
                                                               to={ `/partnership/${row?.partnerId}`}
                                                               state={{row:row}}
                                                            >
                                                                */}
                                                               
                                                                <VisibilityOutlinedIcon className={PartnershipStyles.Tableicon} style={{ marginRight: '10%' }} onClick={() => handleView(row)} />

                                                                <Modal
                                                            open={view}
                                                            onClose={handleViewClose}
                                                            aria-labelledby="modal-modal-title"
                                                            aria-describedby="modal-modal-description"

                                                            BackdropProps={{
                                                                timeout: 500,
                                                                style: { backgroundColor: '#454545',opacity:'30%' } 
                                                              }}
                                                              slotProps={{
                                                                backdrop: {
                                                                  timeout: 500,
                                                                },
                                                              }
                                                    }
                                                        >
                                                            <Box sx={style} className={PartnershipStyles.formStart}>
                                                                <form action='' method=''>
                                                                    <label>Name</label>
                                                                    <Box className={PartnershipStyles.form}>
                                                                        <input text='text' value={selectedData?.partnerName} disabled></input>
                                                                    </Box>
                                                                    <label>Email</label>
                                                                    <Box className={PartnershipStyles.form}>
                                                                        <input text='text' value={selectedData?.email} disabled></input>
                                                                    </Box>

                                                                    <label>CompanyName</label>
                                                                    <Box className={PartnershipStyles.form}>
                                                                        <input text='text' value={selectedData?.companyName} disabled></input>
                                                                    </Box>

                                                                    <label>CompanyWebsite</label>
                                                                    <Box className={PartnershipStyles.form}>
                                                                        <input text='text' value={selectedData?.companyWebsite} disabled></input>
                                                                    </Box>

                                                                    <label>Type</label>
                                                                    <Box className={PartnershipStyles.form}>
                                                                        <input text='text' value={selectedData?.rolesDetails} disabled></input>
                                                                    </Box>

                                                                    <label>Phone Number</label>
                                                                    <Box className={PartnershipStyles.form}>
                                                                        <input text='text' value={selectedData?.mobileNumber} disabled></input>
                                                                    </Box>
                                                                    {/* <label>Message</label>
                                                                    <Box className={PartnershipStyles.form}>
                                                                        <textarea text='text' col="10" rows="8" value={selectedData?.contactUsMessage} disabled></textarea>
                                                                    </Box> */}
                                                                </form>
                                                            </Box>
                                                        </Modal>
                                                            {/* </Link> */}
                                                            <Link disableRipple onClick={() => deleteApplicantbyId(row.partnerId)}>
                                                                <DeleteForeverOutlinedIcon style={{marginLeft:'10%'}} className={PartnershipStyles.Tableicon} />
                                                            </Link>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                  
                                   }


                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            style={{paddingTop:'2%'}}

                        />
                    </Paper>
                </CardContent>
            </Card>
        </>
    )
}

export default Partnership